import styles from './header-search-bar-suggestions-separator.module.scss';

export const HeaderSearchBarSuggestionsSeparator = () => (
  <div
    className={`${styles['header-search-bar-suggestions-separator']} d-none d-md-block`}
  />
);
